
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0C115.031 0 0 115.05 0 256c0 45.756 12.379 90.551 35.869 130.02L.758 492.294a15 15 0 0019.1 18.898l105.201-36.007C165.462 499.293 210.578 512 256 512c140.97 0 256-115.049 256-256C512 115.03 396.951 0 256 0zm0 482c-42.064 0-83.934-12.438-121.083-35.969a15 15 0 00-12.884-1.52l-83.315 28.516 27.822-84.212a14.999 14.999 0 00-1.571-12.732C42.092 339.967 30 298.443 30 256 30 131.383 131.384 30 256 30s226 101.383 226 226-101.383 226-226 226z"}}),_c('path',{attrs:{"d":"M254.624 61C197.486 61 151 107.485 151 164.623c0 24.813 20.187 45 45 45s45-20.187 45-45c0-7.512 6.111-13.623 13.623-13.623 9.03 0 16.377 7.347 16.377 16.377v3.193c0 4.374-1.706 8.493-4.791 11.586l-33.237 33.237C218.804 229.562 211 248.395 211 268.422V286c0 24.813 20.187 45 45 45s45-20.187 45-45v-11.365l28.844-28.844C349.936 225.7 361 198.986 361 170.57 361 104.447 310.126 61 254.624 61zm54.007 163.578l-33.237 33.237A15 15 0 00271 268.422V286c0 8.271-6.729 15-15 15s-15-6.729-15-15v-17.578c0-12.014 4.683-23.313 13.185-31.815l33.25-33.25c8.748-8.77 13.565-20.413 13.565-32.787v-3.193C301 141.805 280.196 121 254.624 121 230.57 121 211 140.569 211 164.623c0 8.271-6.729 15-15 15s-15-6.729-15-15C181 124.027 214.028 91 254.624 91c39 0 76.376 30.026 76.376 79.57 0 20.402-7.944 39.583-22.369 54.008zM256 361c-24.813 0-45 20.187-45 45s20.187 45 45 45 45-20.187 45-45-20.187-45-45-45zm0 60c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z"}})])
          )
        }
      }
    